import { render, staticRenderFns } from "./hubconnectionstatus.vue?vue&type=template&id=18010552&"
import script from "./hubconnectionstatus.vue?vue&type=script&lang=ts&"
export * from "./hubconnectionstatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports